module.exports = __webpack_public_path__ + "img/lct_icon.9c76502c.svg";